import React, { CSSProperties } from "react";
import { GetMarginStyle, GetPaddingStyle, SpacingStyle } from "core/styles/paddingMarginStyle.js";
import { Img } from "./_IconStyle.js";

export type Props = SpacingStyle & {
  src?: string | null;
  size?: number;
  marginRight?: string;
  round?: boolean;
  position?: string;
  className?: string;
  width?: number | string;
  onClick?: React.MouseEventHandler;
  objectFit?: string;
  height?: number | string;
  "data-testid"?: string;
  style?: CSSProperties;
  id?: string;
} & GetMarginStyle &
  GetPaddingStyle;

function Icon(props: Props) {
  const { src, size, marginRight, round, "data-testid": dataTestId, ...rest } = props;

  return (
    <Img
      src={src}
      size={size}
      round={round}
      marginRight={marginRight}
      data-testid={dataTestId}
      {...rest}
    />
  );
}

export default Icon;
